/* eslint-disable */
import React, {useState} from 'react';
import 'contents/assets/scss/page/promotion.scss';
import Paging from '../../component/Inc/Paging';
import Tab from '../../component/Inc/Tab';
import PopPRBooklet from './_PopPRBooklet';

const PRBooklet = () => {
  const [tabIdx, setTabIdx] = useState(0);
  const [modalPRBooklet, setModalPRBooklet] = useState(false);
  const tab = [
    {title: '배송 신청', value: 0},
    {title: '배송 완료', value: 1},
    {title: '배송 불가', value: 2, type: 'red'},
    {title: '내 신청', value: 3, type: 'red'}
  ];
  return (
    <main className="com_container p_pr_booklet">
      <div className="com_center_wrap">
        <section className="com_tit_wrap">
          <h2 className="com_pg_tit icon menu7_6">홍보 책자 발송 목록</h2>
          <button
            onClick={() => {
              setModalPRBooklet(true);
            }}
            className="com_btn orange s btn_plus"
          >
            홍보책자 발송 신청
          </button>
        </section>
        <section className="com_pg_container">
          <section className="box">
            <div className="com_board_list__top">
              <Tab data={tab} tab={tabIdx} setTab={setTabIdx} tabStyle="fit_cont" />
              <section className="com_board_search end">
                <div className="date_wrap">
                  <input type="date" className="com_datepicker" placeholder="2022. 01. 01" />
                  <span className="divider"> ~ </span>
                  <input type="date" className="com_datepicker" placeholder="2022. 01. 01" />
                </div>
                <article className="search">
                  <input type="search" placeholder="검색할 내용을 입력" className="input s type_search" />
                  <button className="com_btn gray ws s icon_search"></button>
                </article>
              </section>
            </div>
            <table className="com_board_list">
              <colgroup>
                <col width="7%" />
                <col width="15%" />
                <col width="10%" />
                <col width="10%" />
                <col width="10%" />
                <col width="15%" />
                <col width="20%" />
                <col width="10%" />
              </colgroup>
              <thead>
                <tr>
                  <th>No.</th>
                  <th>요청일</th>
                  <th>요청자</th>
                  <th>배송지</th>
                  <th>전화번호</th>
                  <th>홍보물 명</th>
                  <th>내용</th>
                  <th>상태</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>17</td>
                  <td className="td_date">2023, 05, 20 12 : 30</td>
                  <td>
                    <button className="btn_link">가길동201</button>
                  </td>
                  <td>
                    경기도 수원시
                    <br />
                    수원대로103
                  </td>
                  <td>010-1234-1324</td>
                  <td className="td_left">
                    - 교재 홍보물
                    <br />- 교재 홍보물 2
                  </td>
                  <td>
                    학생 스터디 카페 모임에
                    <br />
                    나눕니다.
                  </td>
                  <td>
                    <button className="btn_link red">발송요청</button>
                  </td>
                </tr>
                <tr>
                  <td>16</td>
                  <td className="td_date">2023, 05, 20 12 : 30</td>
                  <td>
                    <button className="btn_link">가길동201</button>
                  </td>
                  <td>
                    경기도 수원시
                    <br />
                    수원대로103
                  </td>
                  <td>010-1234-1324</td>
                  <td className="td_left">
                    - 교재 홍보물
                    <br />- 교재 홍보물 2
                  </td>
                  <td>
                    학생 스터디 카페 모임에
                    <br />
                    나눕니다.
                  </td>
                  <td className="td_point">-</td>
                </tr>
                <tr className="selected">
                  <td>15</td>
                  <td className="td_date">2023, 05, 20 12 : 30</td>
                  <td>
                    <button className="btn_link">가길동201</button>
                  </td>
                  <td>
                    경기도 수원시
                    <br />
                    수원대로103
                  </td>
                  <td>010-1234-1324</td>
                  <td className="td_left">
                    - 교재 홍보물
                    <br />- 교재 홍보물 2
                  </td>
                  <td>
                    학생 스터디 카페 모임에
                    <br />
                    나눕니다.
                  </td>
                  <td>
                    <button className="btn_link blue">
                      승인
                      <br />
                      2023, 05, 12
                    </button>
                  </td>
                </tr>
                <tr>
                  <td>14</td>
                  <td className="td_date">2023, 05, 20 12 : 30</td>
                  <td>
                    <button className="btn_link">가길동201</button>
                  </td>
                  <td>
                    경기도 수원시
                    <br />
                    수원대로103
                  </td>
                  <td>010-1234-1324</td>
                  <td className="td_left">
                    - 교재 홍보물
                    <br />- 교재 홍보물 2
                  </td>
                  <td>
                    학생 스터디 카페 모임에
                    <br />
                    나눕니다.
                  </td>
                  <td>
                    <button className="btn_link red">
                      승인불가
                      <br />
                      2022,08,25
                    </button>
                  </td>
                </tr>
                {[1, 2, 3, 4, 5, 6, 7].map((i, idx) => {
                  return (
                    <tr key={idx}>
                      <td>{13 - idx}</td>
                      <td className="td_date">2023, 05, 20 12 : 30</td>
                      <td>
                        <button className="btn_link">가길동201</button>
                      </td>
                      <td>
                        경기도 수원시
                        <br />
                        수원대로103
                      </td>
                      <td>010-1234-1324</td>
                      <td className="td_left">
                        - 교재 홍보물
                        <br />- 교재 홍보물 2
                      </td>
                      <td>
                        학생 스터디 카페 모임에
                        <br />
                        나눕니다.
                      </td>
                      <td className="td_point">-</td>
                    </tr>
                  );
                })}
                <tr>
                  <td>7</td>
                  <td className="td_date">2023, 05, 20 12 : 30</td>
                  <td>가길동201</td>
                  <td>
                    경기도 수원시
                    <br />
                    수원대로103
                  </td>
                  <td>010-1234-1324</td>
                  <td className="td_left">
                    - 교재 홍보물
                    <br />- 교재 홍보물 2
                  </td>
                  <td>
                    학생 스터디 카페 모임에
                    <br />
                    나눕니다.
                  </td>
                  <td className="td_point">-</td>
                </tr>
                <tr>
                  <td>7</td>
                  <td className="td_date">2023, 05, 20 12 : 30</td>
                  <td>가길동201</td>
                  <td>
                    경기도 수원시
                    <br />
                    수원대로103
                  </td>
                  <td>010-1234-1324</td>
                  <td className="td_left">
                    - 교재 홍보물
                    <br />- 교재 홍보물 2
                  </td>
                  <td>
                    학생 스터디 카페 모임에
                    <br />
                    나눕니다.
                  </td>
                  <td className="td_point">-</td>
                </tr>
                <tr>
                  <td>7</td>
                  <td className="td_date">2023, 05, 20 12 : 30</td>
                  <td>가길동201</td>
                  <td>
                    경기도 수원시
                    <br />
                    수원대로103
                  </td>
                  <td>010-1234-1324</td>
                  <td className="td_left">
                    - 교재 홍보물
                    <br />- 교재 홍보물 2
                  </td>
                  <td>
                    학생 스터디 카페 모임에
                    <br />
                    나눕니다.
                  </td>
                  <td className="td_point">-</td>
                </tr>
              </tbody>
            </table>
						<div className="paging_wrap">
             <Paging />
					  	<button className="com_btn black xs btn_down_orange">다운로드</button>
						</div>

          </section>
          <section className="box">
            <div className="detail_tit dot">상세보기</div>
            <div className="com_info">
              <p className="name">홍길동103</p>
              <p className="date dot">2025, 05, 20 11 : 30</p>
              <div className="count">
                <button className="btn_edit" />
                <button className="btn_delete" />
              </div>
            </div>
            <div className="com_board_box">
              <div className="board_item">
                <div className="info">
                  <span className="tit">홍보책자 영역</span>
                  <span className="cont">과학탐구</span>
                </div>
                <div className="info">
                  <span className="tit">홍보책자 명</span>
                  <span className="cont com_blue_txt">2023 이지 홍보책자</span>
                </div>
              </div>
              <div className="board_item">
                <div className="info">
                  <span className="tit">받는사람</span>
                  <span className="cont com_blue_txt">(교사) 김교사103</span>
                </div>
                <div className="info">
                  <span className="tit">전화번호</span>
                  <span className="cont">010-1234-1324</span>
                </div>
                <div className="info">
                  <span className="tit">배송지</span>
                  <span className="cont">서울특별시 강남구 강남대로103번지 금강빌딩103호</span>
                </div>
              </div>
              <div className="board_item">
                <div className="info">
                  <span className="tit">받는사람</span>
                  <span className="cont com_blue_txt">(교사) 김교사103</span>
                </div>
                <div className="info">
                  <span className="tit">전화번호</span>
                  <span className="cont">010-1234-1324</span>
                </div>
                <div className="info">
                  <span className="tit">배송지</span>
                  <span className="cont">서울특별시 강남구 강남대로103번지 금강빌딩103호</span>
                </div>
              </div>
            </div>
            <div className="com_comment_wrap">
              <textarea className="textarea" placeholder="메모 내용"></textarea>
            </div>
            <div className="com_board_box">
              <div className="board_item">
                <div className="info">
                  <span className="cont">
                    <span className="com_icon blue">승인</span>
                    <button className="name">김홍보105</button>
                    <span className="date dot">2025, 05, 20 11 : 30</span>
                  </span>
                </div>
                <hr className="com_divider" />
                <div className="info">수고 하셨습니다.</div>
              </div>
            </div>
            <div className="com_btn_wrap flex_row">
              <button className="com_btn black xs btn_print">이 내용 송장 출력</button>
            </div>
            <hr className="com_divider" />
            <div className="com_input_wrap">
              <div className="check">
                <input type="radio" name="rdo" id="rdo01" className="com_chk circle" />
                <label htmlFor="rdo01">승인</label>
                <input type="radio" name="rdo" id="rdo02" className="com_chk circle" />
                <label htmlFor="rdo02">반려</label>
              </div>
            </div>
            <div className="com_comment_wrap">
              <textarea className="textarea small" placeholder="내용 입력"></textarea>
            </div>
            <div className="com_btn_wrap center bottom">
              <button className="com_btn orange xs">등록</button>
            </div>
          </section>
        </section>
      </div>
      <PopPRBooklet open={modalPRBooklet} close={() => setModalPRBooklet(false)} />
    </main>
  );
};

export default PRBooklet;
